<!--  -->
<template>
  <div v-loading="loading">
    <!-- <div class="back">
      <img
        :src="'https://puui.qpic.cn/vupload/0/20200709_mixpjrqf0a/0'"
        class="details-img"
        @click="goBack"
      />
      <div class="details-return" @click="goBack">返回</div>
    </div> -->
    <el-form>
      <el-form-item label="发布渠道：" label-width="100">
        <div>{{ channelType }} {{ channelName }}</div>
      </el-form-item>
      <el-form-item label="查看权限：" label-width="100">
        <el-radio v-model="permission" :label="1">公开</el-radio>
        <span v-if="channelType === '公众号'">
          <el-radio v-model="permission" :label="2" :disabled="channelPublicType === 1">
            关注公众号
          </el-radio>
          <el-radio v-model="permission" :label="3">登录可查看</el-radio>
        </span>
        <span v-show="channelType === '企业微信'">
          <el-radio v-model="permission" :label="5">企业内部</el-radio>
        </span>
      </el-form-item>
      <el-form-item v-show="permission === 3" label="查看策略：">
        <el-select v-model="listStrategy" multiple collapse-tags placeholder="请选择">
          <el-option
            v-for="strategy in strategyList"
            :key="strategy.id"
            :label="strategy.name"
            :value="strategy.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="[4, 5, 7].includes(permission)" label="查看范围：" label-width="100">
        <selectViewRange
          ref="viewRangeAll"
          :agent-id="Number(channelId)"
          :disable-select-all="true"
        ></selectViewRange>
      </el-form-item>
      <el-form-item label="文章是否可以收藏：">
        <el-radio v-model="canCollect" :label="2">可以</el-radio>
        <el-radio v-model="canCollect" :label="1">不能</el-radio>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <div class="contant">
      <!-- 右侧编辑 -->
      <div class="right">
        <div class="right-tit">
          <el-form inline>
            <el-form-item label="请输入标题名称">
              <el-input
                type="text"
                show-word-limit
                maxlength="16"
                v-model.trim="name"
                placeholder="请输入标题名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 运营位列表 -->
        <div class="oprating-list">
          <div class="operat-title">
            <span>运营位列表</span>
            <div class="right-operating">
              <el-button type="text" @click="handleOperat">添加</el-button>
              <el-button
                v-if="!drag"
                type="text"
                @click="rowDrop('bannerData', bannerData, 'drag')"
              >
                开启拖拽排序
              </el-button>
              <el-button v-if="drag" type="text" @click="closeRowDrop('drag')">
                关闭拖拽排序
              </el-button>
            </div>
          </div>
          <el-table :data="bannerData" class="bannerData" :show-header="false" row-key="banner_id">
            <el-table-column prop="title"></el-table-column>
            <el-table-column align="right">
              <template slot-scope="scope">
                <el-button
                  style="font-size: 20px"
                  class="el-icon-delete"
                  type="text"
                  @click="handleDelectBanner(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 通知栏 -->
        <div class="oprating-list">
          <div class="operat-title">
            <span>
              通知栏
              <i>（最多可添加4个，每个最多输入8个汉字）</i>
            </span>
            <div class="right-operating">
              <el-button
                type="text"
                @click="noticeVisible = !noticeVisible"
                :disabled="noticeList.length >= 4"
              >
                添加
              </el-button>
              <el-button v-if="!dragNoticeList" type="text" @click="rowDropNotice">
                开启拖拽排序
              </el-button>
              <el-button v-if="dragNoticeList" type="text" @click="closeRowDropNotice">
                关闭拖拽排序
              </el-button>
            </div>
          </div>
          <el-table class="noticeList" :data="noticeList" :show-header="false" row-key="Title">
            <el-table-column prop="Title"></el-table-column>
            <el-table-column align="right">
              <template slot-scope="scope">
                <el-button
                  style="font-size: 20px"
                  class="el-icon-delete"
                  type="text"
                  @click="handleDelectNotice(scope.$index, noticeList)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="oprating-list">
          <div class="operat-title">
            <span>
              项目列表
              <i>（最多可添加15个，每个最多输入20个汉字）</i>
            </span>
            <div class="right-operating">
              <el-button
                type="text"
                @click="projectVisible = true"
                :disabled="projectList.length >= 15"
              >
                添加
              </el-button>
              <el-button v-if="!dragProjectList" type="text" @click="rowDropProject">
                开启拖拽排序
              </el-button>
              <el-button v-if="dragProjectList" type="text" @click="closeRowDropProject">
                关闭拖拽排序
              </el-button>
            </div>
          </div>
          <el-table :data="projectList" class="projectList" :show-header="false" row-key="Title">
            <el-table-column prop="Icon" width="100" align="center">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.Icon"
                  :src="scope.row.Icon"
                  style="width: 52px; height: 52px"
                  alt="图标"
                />
              </template>
            </el-table-column>
            <el-table-column prop="Title">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column">
                  <div style="color: #1a2734">{{ scope.row.Title }}</div>
                  <div style="overflow: hidden; text-overflow: ellipsis">
                    {{ scope.row.Desc }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template slot-scope="scope">
                <div
                  class="color-selector-inner"
                  :style="{ 'background-color': scope.row.Color }"
                ></div>
                <el-button
                  style="font-size: 20px"
                  class="el-icon-edit"
                  type="text"
                  @click="handleEditProject(scope.$index)"
                ></el-button>
                <el-button
                  style="font-size: 20px"
                  class="el-icon-delete"
                  type="text"
                  @click="handleDelectNotice(scope.$index, projectList)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="article-classify">
          <div class="options">
            <el-tabs v-model="editableTabsValue" type="border-card">
              <div v-show="editableTabs.length === 0" class="no-tab-container">
                <span class="no-tab-span">当前暂无分类</span>
                <el-button @click="addTab()">添加分类</el-button>
              </div>
              <el-tab-pane
                v-for="item in editableTabs"
                :key="item.ah5_group_id"
                :label="item.group_name"
                :name="item.ah5_group_id"
              >
                <el-form inline @submit.native.prevent>
                  <el-form-item label="修改分类名称：">
                    <el-input
                      placeholder="请按回车修改"
                      show-word-limit
                      v-model.trim="modify"
                      :maxlength="6"
                      @keyup.enter.native="handleChange"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="addTab(editableTabsValue)">添加分类</el-button>
                    <el-button @click="handleDetectClassification">删除</el-button>
                  </el-form-item>
                </el-form>
                <div class="add-artilce">
                  <div>
                    <span class="span1">文章列表</span>
                    <span class="span2">（根据标签选择文章）</span>
                  </div>
                  <el-button type="text" @click="handleAddArticle">添加文章</el-button>
                </div>
                <el-form style="display: block">
                  <el-form-item label="查看权限：">
                    <el-radio v-model="item.permission.permission" :label="1">公开</el-radio>
                    <el-radio
                      v-model="item.permission.permission"
                      v-if="channelType === '公众号'"
                      :disabled="permission === 1 || permission === 2"
                      :label="6"
                    >
                      访问策略
                    </el-radio>
                    <el-radio
                      v-model="item.permission.permission"
                      v-if="channelType === '企业微信'"
                      :disabled="permission === 1"
                      :label="5"
                    >
                      企业内部
                    </el-radio>
                  </el-form-item>
                  <el-form-item v-show="item.permission.permission === 6" label="访问策略：">
                    <el-select v-model="item.strategy" multiple collapse-tags placeholder="请选择">
                      <el-option
                        v-for="strategy in strategyList"
                        :key="strategy.id"
                        :label="strategy.name"
                        :value="strategy.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-show="item.permission.permission === 5" label="访问用户：">
                    <selectViewRange
                      ref="viewRangeTab"
                      :agent-id="Number(channelId)"
                      :disable-select-all="true"
                    ></selectViewRange>
                  </el-form-item>
                </el-form>
                <el-table :data="item.arts" :show-header="false" v-loading="tabLoading">
                  <el-table-column prop="title"></el-table-column>
                  <el-table-column align="right">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        v-if="scope.row.istop === 1"
                        @click="handleTop(scope.row.art_id, scope.$index)"
                      >
                        置顶
                      </el-button>
                      <el-button
                        type="text"
                        v-if="scope.row.istop === 2"
                        @click="handleNotop(scope.row.art_id, scope.$index)"
                      >
                        取消置顶
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!-- 底部工具栏 -->
        <div class="oprating-list">
          <div class="operat-title">
            <span>
              底部工具栏
              <i>（最多可添加5个，每个最多输入5个汉字）</i>
            </span>
            <div class="right-operating">
              <el-button
                type="text"
                @click="toolbarVisible = !toolbarVisible"
                :disabled="toolbarList.length >= 5"
              >
                添加
              </el-button>
              <el-button v-if="!dragToolbar" type="text" @click="rowDropToolbar">
                开启拖拽排序
              </el-button>
              <el-button v-if="dragToolbar" type="text" @click="closeRowDropToolbar">
                关闭拖拽排序
              </el-button>
            </div>
          </div>
          <el-table :data="toolbarList" class="toolbarList" :show-header="false" row-key="Title">
            <el-table-column prop="Title"></el-table-column>
            <el-table-column align="right">
              <template slot-scope="scope">
                <el-button
                  style="font-size: 20px"
                  class="el-icon-delete"
                  type="text"
                  @click="handleDelectNotice(scope.$index, toolbarList)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="submit">
      <el-button @click="hanldeH5Preview">预览</el-button>
      <el-button type="primary" plain @click="handleSave">保存</el-button>
      <el-button type="danger" plain @click="handleRelease">发布</el-button>
    </div>
    <!-- 添加通知栏 -->
    <el-dialog
      title="添加通知栏"
      :visible.sync="noticeVisible"
      width="800px"
      @close="noticeDialogClose"
    >
      <el-form label-position="left" ref="form" :model="noticeForm" label-width="102px">
        <el-form-item label="名称:" prop="name">
          <el-input
            maxlength="8"
            v-model.trim="noticeForm.Title"
            placeholder="请输入名称"
            class="outAppInput"
          />
          <!-- <i classs="promptText" style="color: #909399">
            仅支持中英文和数字，字数不超过8个汉字
          </i> -->
        </el-form-item>
        <el-form-item label="图标:" prop="icon">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :http-request="handleRequest"
          >
            <img v-if="noticeForm.Icon" :src="noticeForm.Icon" class="avatar" />
            <i v-else class="el-icon-plus" />
          </el-upload>
          <i classs="promptText" style="color: #909399">图标大小为32*32px，格式为png、jpg</i>
        </el-form-item>
        <el-form-item label="跳转连接:" prop="link">
          <el-input
            v-model.trim="noticeForm.Link"
            placeholder="请输入跳转连接"
            class="outAppInput"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="danger" plain @click="noticeVisible = !noticeVisible">取消</el-button>
        <el-button type="primary" plain @click="saveNotice(1, noticeList)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加底部工具栏 -->
    <el-dialog
      title="添加底部工具栏菜单"
      :visible.sync="toolbarVisible"
      width="800px"
      @close="toolbarDialogClose"
    >
      <el-form label-position="left" ref="form" :model="toolbarForm" label-width="102px">
        <el-form-item label="名称:" prop="name">
          <el-input
            maxlength="5"
            v-model.trim="toolbarForm.Title"
            placeholder="请输入名称"
            class="outAppInput"
          />
        </el-form-item>
        <el-form-item label="图标:" prop="icon">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :http-request="handleRequest"
          >
            <img v-if="toolbarForm.Icon" :src="toolbarForm.Icon" class="avatar" />
            <i v-else class="el-icon-plus" />
          </el-upload>
          <i classs="promptText" style="color: #909399">图标大小为48*48px，格式为png、jpg</i>
        </el-form-item>
        <el-form-item label="跳转连接:" prop="link">
          <el-input
            v-model.trim="toolbarForm.Link"
            placeholder="请输入跳转连接"
            class="outAppInput"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="danger" plain @click="toolbarVisible = !toolbarVisible">取消</el-button>
        <el-button type="primary" plain @click="saveNotice(2, toolbarList)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加项目 -->
    <el-dialog
      title="添加项目菜单"
      :visible.sync="projectVisible"
      width="800px"
      @close="projectDialogClose"
    >
      <el-form
        label-position="left"
        ref="projectForm"
        :show-message="false"
        :model="projectForm"
        label-width="142px"
      >
        <el-form-item label="项目名称:" prop="Title" required>
          <el-input
            maxlength="20"
            v-model.trim="projectForm.Title"
            placeholder="最多输入20个汉字"
            class="outAppInput"
          />
        </el-form-item>
        <el-form-item label="描述:" prop="Desc">
          <el-input
            maxlength="40"
            v-model.trim="projectForm.Desc"
            placeholder="最多输入40个汉字"
            class="outAppInput"
          />
        </el-form-item>
        <el-form-item label="图标(非必填):" prop="icon">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :http-request="handleRequest"
          >
            <img
              v-if="projectForm.Icon"
              :src="projectForm.Icon"
              style="width: 100px; height: 100px"
              alt="图标"
            />
            <div
              v-if="projectForm.Icon !== defaultProjectIcon"
              class="icon-delete"
              @click.stop="resetProjectIcon"
            >
              删除
            </div>
          </el-upload>
          <i class="promptText" style="color: #909399">
            图标大小为32*32px，格式为png、jpg 图标背景建议设置为透明
          </i>
        </el-form-item>
        <el-form-item label="颜色：" prop="Color" required>
          <div class="color-container">
            <div
              v-for="color in colors"
              :key="color"
              class="color-selector"
              :class="[projectForm.Color === color ? 'color-selected' : '']"
              @click="projectForm.Color = color"
            >
              <div class="color-selector-inner" :style="{ 'background-color': color }"></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="跳转连接:" prop="Link" required>
          <el-input
            v-model.trim="projectForm.Link"
            placeholder="请输入跳转连接"
            class="outAppInput"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="danger" plain @click="projectVisible = false">取消</el-button>
        <el-button type="primary" plain @click="saveProject()">保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加运营位弹窗 -->
    <div v-if="operatVisible">
      <el-dialog title="添加运营位" :visible.sync="operatVisible" width="850px" center>
        <el-tabs>
          <el-tab-pane label="H5渠道">
            <imgTab
              :check="bannerData"
              :list="H5OperaBanner"
              :channel="channelType"
              @checkedChange="H5SelectionChange"
              v-loading="bannerDataLoading"
            ></imgTab>
          </el-tab-pane>
        </el-tabs>
        <div style="margin-top: 20px; float: right">
          <el-pagination
            style="background-color: #ffffff"
            layout="prev, pager, next"
            :total="H5OperaPageTotal"
            :page-size="H5OperaPageSize"
            :current-page="H5OperaPageIndex"
            @current-change="handleOperaIndexChange"
          />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="operatVisible = false">取 消</el-button>
          <el-button type="primary" @click="addOperaBannerList">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 添加文章 -->
    <div v-if="articleVisible">
      <el-dialog title="添加文章" :visible.sync="articleVisible" width="800px" center>
        <el-tabs v-model="labelName">
          <el-tab-pane label="产品" name="product">
            <div class="header">
              <el-checkbox
                :indeterminate="product.indeterminate"
                v-model="product.checkAll"
                @change="handleProductCheckAll()"
              >
                全选
              </el-checkbox>
            </div>
            <div class="content">
              <el-checkbox-group v-model="product.checked" class="add-article-checkbox-group">
                <div
                  v-for="label in product.list"
                  :key="label.id"
                  class="add-article-checkbox-container"
                >
                  <el-checkbox
                    :label="label"
                    :title="label.product_name"
                    class="add-article-checkbox"
                    @change="handleProductCheckChange()"
                  >
                    <span class="box">{{ label.product_name }}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-for="labelGroup in labelGroupList"
            :label="labelGroup.GroupName"
            :name="labelGroup.GroupName"
            :key="labelGroup.id"
          >
            <div class="header">
              <el-checkbox
                :indeterminate="labelGroup.indeterminate"
                v-model="labelGroup.checkAll"
                @change="handleCheckAll(labelGroup.id)"
              >
                全选
              </el-checkbox>
            </div>
            <div class="content">
              <el-checkbox-group
                v-model="labelGroup.selectValue"
                class="add-article-checkbox-group"
              >
                <div
                  v-for="label in labelGroup.LabelList"
                  :key="label.Id"
                  class="add-article-checkbox-container"
                >
                  <el-checkbox
                    :label="label"
                    :title="label.LabelName"
                    class="add-article-checkbox"
                    @change="handleCheckChange(labelGroup.id)"
                  >
                    <span class="box">{{ label.LabelName }}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button @click="articleVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleCheckLabel">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-if="h5PreviewVisible">
      <el-dialog :visible.sync="h5PreviewVisible" width="450px" top="10vh" center>
        <iframe
          :src="h5Preview"
          frameborder="0"
          width="400"
          height="700"
          style="margin: 0 auto; display: block"
        ></iframe>
        <span slot="footer" class="dialog-footer">
          <el-button @click="h5PreviewVisible = false">返回</el-button>
          <el-button type="primary" @click="handleRelease">发布</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/* eslint no-param-reassign: "off" */
import { CosMixin } from '@/mixins/cos';
import imgTab from './components/imgTab.vue';
import selectViewRange from '@/components/selectViewRange';
import Sortable from 'sortablejs';
import { query } from '@/libs/utils/util';
import { GetBanners, GetAllLabelInfoList } from '@/api/releaseManagement.js';
import {
  // getStrategyList,
  getAppListApi,
  GetProductInfoList,
  GetStrategyListByAppID,
  // GetLabelInfoList,
  // GetProductInfoList,
} from '@/api/setUser.js';
import { GetArticleH5ByTagID, AEditArticleH5, GetArticleH5ByID } from '@/api/artilceList.js';
import { mapGetters } from 'vuex';
import { awaitInterfaceResponse, getMobileDomain } from '@/utils/util';
export default {
  components: {
    imgTab,
    selectViewRange,
  },
  mixins: [CosMixin],
  data() {
    return {
      ah5_id: '',
      btnType: '',
      url: getMobileDomain(),
      protocol: 'https',
      channelType: '',
      channelName: '',
      channelId: '',
      channelAppId: '',
      channelPublicType: 0,
      permission: 1,
      listStrategy: [],
      listViewRangeList: [],
      canCollect: 2,
      dragDorp: null,
      dragDorpNotice: null,
      dragDorpToolbar: null,
      dragDropProject: null,
      drag: false,
      bannerDataLoading: false,
      loading: false,
      tabLoading: false,
      H5OperaBanner: [], // H5运营位列表
      H5OperaPageIndex: 1, // H5运营为分页页码
      H5OperaPageSize: 6, // H5运营为分页大小
      H5OperaPageTotal: 1, // H5运营为分页大小
      selectH5Banner: [],
      operatVisible: false,
      articleVisible: false,
      setViewRangeVisible: false,
      modify: '',
      editableTabsValue: '', // 文章列表tab默认展示
      strategyList: [], // 公众号采用的策略列表
      editableTabs: [
        {
          group_name: '新增分类1',
          ah5_group_id: '1',
          arts: [],
          top_art_ids: [],
          lableData: [],
          permission: {
            type: 2,
            permission: 1,
            value: '',
          },
          strategy: [],

          productLabelChecked: [],
          diseaseLabelChecked: [],
          otherLabelChecked: [],
        },
      ],
      tabIndex: '1',
      name: '',
      bannerData: [],
      selectionData: [],
      labelName: 'product',
      labelGroupList: [], // 标签列表
      product: {
        // 产品标签
        list: [],
        checked: [],
        indeterminate: false,
        checkAll: false,
      },

      h5Preview: '',
      h5PreviewVisible: false,
      lableGroup: [],

      checkBoxAll: [],
      checkBanner: [],
      noticeVisible: false, // 通知栏弹窗
      toolbarVisible: false, // 底部工具栏弹窗
      projectVisible: false, // 项目弹窗
      noticeList: [],
      toolbarList: [],
      projectList: [],
      // 通知栏
      noticeForm: {
        Title: '',
        Icon: 'https://baike-med-1256891581.file.myqcloud.com/2021081/b7b1aba0-f8dc-11eb-91d1-3368cd681d02_0.svg',
        Link: '',
      },
      // 工具栏
      toolbarForm: {
        Title: '',
        Icon: 'https://baike-med-1256891581.file.myqcloud.com/2021086/b7aeec80-f8dc-11eb-8e3d-f307aeb71f0d_0.svg',
        Link: '',
      },
      defaultProjectIcon:
        'https://baike-med-1256891581.file.myqcloud.com/2022032/d1678240-aa75-11ec-acc4-2daa03d2616b_0.svg',
      projectForm: {
        Title: '',
        Icon: 'https://baike-med-1256891581.file.myqcloud.com/2022032/d1678240-aa75-11ec-acc4-2daa03d2616b_0.svg',
        Link: '',
        Desc: '',
        Color: '',
      },
      dragNoticeList: false,
      dragToolbar: false,
      dragProjectList: false,
      status: false, // 是否发布
      colors: [
        '#f56e64',
        '#ff8547',
        '#ffb300',
        '#7ccc21',
        '#76c433',
        '#1fc48d',
        '#23cdd9',
        '#1f8fff',
        '#ab88f2',
        '#e65ed3',
      ],
      projectEdit: false,
      projectEditIndex: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      enterpriseId: 'getEnterpriseId',
    }),
  },
  watch: {
    permission: {
      handler(val) {
        switch (val) {
          case 1:
          case 2:
            // 当权限重设为公开/关注公众号时，将分类权限都设为公开
            this.editableTabs.forEach((item) => {
              item.permission.permission = 1;
            });
            break;
        }
      },
    },
  },
  created() {
    let title = '新建列表页';
    if (this.$route.query.type === 'edit') {
      title = '编辑列表页';
    }

    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '' },
      { menu_name: '文章列表', menu_path: 'artilceList' },
      { menu_name: title },
    ];
    this.$store.commit('user/setBreadcrumb', breadcrumb);

    if (
      this.$route.query.type === 'edit' ||
      (this.$route.query.type === 'add' && this.$route.query.ah5_id)
    ) {
      this.getDeail();
    } else {
      this.channelType = query('channelType') || '未知';
      this.channelName = query('channelName') || '未知';
      this.channelId = query('channelId') || '未知';
      this.channelAppId = query('channelAppId') || '未知';
      this.channelPublicType = Number(query('channelPublicType'));

      // 获取公众号选择的策略列表
      GetStrategyListByAppID({ app_id: this.channelAppId })
        .then((res) => {
          this.strategyList = res.list;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    }

    this.editableTabsValue = this.editableTabs[0].ah5_group_id;

    // 查询产品标签
    GetProductInfoList({})
      .then((res) => {
        this.$set(this.product, 'list', res.list);
      })
      .catch((e) => {
        this.$message.error(e);
      });

    // 查询所有的动态标签
    GetAllLabelInfoList()
      .then((res) => {
        // console.log(res);
        this.labelGroupList = res.LabelGroupList;
        this.labelGroupList.forEach((item, index) => {
          item.id = index;
          this.$set(item, 'selectValue', []);
          this.$set(item, 'indeterminate', false);
          this.$set(item, 'checkAll', false);
        });
        if (this.labelGroupList.length) {
          this.labelName = this.labelGroupList[0].GroupName;
        }
      })
      .catch((e) => {
        this.$message.error(e);
      });
  },
  methods: {
    // 关闭通知栏弹窗
    noticeDialogClose() {
      Object.assign(this.$data.noticeForm, this.$options.data().noticeForm);
    },
    // 关闭工具栏弹窗
    toolbarDialogClose() {
      Object.assign(this.$data.toolbarForm, this.$options.data().toolbarForm);
    },
    // 关闭项目弹窗
    projectDialogClose() {
      setTimeout(() => {
        Object.assign(this.$data.projectForm, this.$options.data().projectForm);
      }, 300);
    },
    // 上传图标
    async handleRequest(file) {
      if (!/.jpg|.png$/gi.test(file.file.name)) {
        this.$message('只支持上传jpg和png图片');
        return false;
      }
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      this.globalLoading = true;
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
      };
      try {
        const res = await this.putCosObject(cosParams);
        if (this.toolbarVisible) {
          this.toolbarForm.Icon = res.data;
        } else if (this.noticeVisible) {
          this.noticeForm.Icon = res.data;
        } else if (this.projectVisible) {
          this.projectForm.Icon = res.data;
        }
      } catch (err) {
        // console.log(err);
        // this.noticeForm.Icon =
        //   'https://baike-med-1256891581.file.myqcloud.com/2021034/c2c5dee0-8608-11eb-947c-032fa08bea6e_0.png';
        console.log(err);
        this.$message('上传失败，请稍后再试');
      }
      this.globalLoading = false;
    },
    handleCheckAll(index) {
      const label = this.labelGroupList[index];
      if (label.checkAll) {
        this.$set(label, 'selectValue', [...label.LabelList]);
      } else {
        this.$set(label, 'selectValue', []);
      }
      label.indeterminate = false;
    },
    handleCheckChange(index) {
      const label = this.labelGroupList[index];
      if (label.selectValue.length === label.LabelList.length) {
        // 全选
        this.$set(label, 'checkAll', true);
        this.$set(label, 'indeterminate', false);
      } else if (label.selectValue.length === 0) {
        // 全不选
        this.$set(label, 'checkAll', false);
        this.$set(label, 'indeterminate', false);
      } else {
        // 半选
        this.$set(label, 'checkAll', false);
        this.$set(label, 'indeterminate', true);
      }
    },
    handleProductCheckAll() {
      const { checkAll, list } = this.product;
      if (checkAll) {
        this.$set(this.product, 'checked', [...list]);
      } else {
        this.$set(this.product, 'checked', []);
      }
      this.product.indeterminate = false;
    },
    handleProductCheckChange() {
      const { list, checked } = this.product;
      if (checked.length === list.length) {
        // 全选
        this.product.checkAll = true;
        this.product.indeterminate = false;
      } else if (checked.length === 0) {
        // 全不选
        this.product.checkAll = false;
        this.product.indeterminate = false;
      } else {
        // 半选
        this.product.checkAll = false;
        this.product.indeterminate = true;
      }
    },
    getToken() {
      const cookieStr = document.cookie;
      return cookieStr.substring(
        cookieStr.indexOf('saas_token') + 11,
        cookieStr.indexOf(';', cookieStr.indexOf('saas_token')),
      );
    },
    processArticles(data) {
      // 清除置顶文章中失效文章
      data.ah5_class?.groups?.forEach((group) => {
        const articles = group.arts?.map((item) => item.art_id) || [];
        group.top_art_ids = group.top_art_ids?.filter((item) => articles.includes(item));
      });
      return data;
    },
    getDeail() {
      this.loading = true;
      GetArticleH5ByID({
        ah5_id: this.$route.query.ah5_id,
        channel: 1, // 管理端1,移动端0，权限管理的临时解决方案
        token: this.getToken(),
        user_id: '',
      }).then((res) => {
        res = this.processArticles(res);
        this.name = res.ah5_class.name || '';
        this.bannerData = res.ah5_class.banners || '';
        this.status = res.ah5_group.status === 2;
        this.canCollect = res.ah5_class.IsCanCollect || 2;

        // 对发布渠道进行解析处理
        this.channelId = res.Channel.Id;
        this.channelType = res.Channel.Type === 1 ? '公众号' : '企业微信';
        // console.log(this.channelId);
        if (this.channelType === '公众号') {
          awaitInterfaceResponse('enterpriseId', this)
            .then(() => {
              // console.log(this.enterpriseId);
              getAppListApi({
                enterprise_id: this.enterpriseId,
                page_index: 1,
                page_size: 999,
              })
                .then((res) => {
                  const { list } = res;
                  // console.log(list);
                  for (const i of list) {
                    if (i.app_id === this.channelId) {
                      this.channelName = i.app_name;
                      this.channelAppId = i.app_id;
                      this.channelPublicType = i.type;
                      break;
                    }
                  }
                  // 获取公众号选择的策略列表
                  GetStrategyListByAppID({ app_id: this.channelAppId })
                    .then((res) => {
                      this.strategyList = res.list;
                    })
                    .catch((e) => {
                      this.$message.error(e);
                    });
                })
                .catch((err) => {
                  console.error(err);
                  this.$message.error('查询发布渠道失败');
                });
            })
            .catch(() => {
              this.$message.error('无法找到enterpriseId');
            });
        } else if (this.channelType === '企业微信') {
          for (const agent of this.$store.state.user.managerLogin.agent_list) {
            // console.log(agent);
            // console.log(this.channelId);
            if (this.channelId === agent.agent_id) {
              this.channelName = agent.agent_name;
              break;
            }
          }
        }

        this.permission = res.ah5_group.ListPermission.Permission || 1;

        // 对列表查看权限进行解析
        // 不要问我为什么这么复杂，后端设计的
        this.$nextTick(() => {
          if ([4, 5, 7, 8, 9].includes(this.permission)) {
            switch (this.permission) {
              case 4:
                // 只选了部门
                this.$refs.viewRangeAll.setChecked(
                  [],
                  res.ah5_group.ListPermission.Value.split(','),
                );
                break;
              case 5:
                // 只选了用户
                this.$refs.viewRangeAll.setChecked(
                  res.ah5_group.ListPermission.Value.split(','),
                  [],
                );
                break;
              case 7:
                // 部门和人混选
                this.$refs.viewRangeAll.setChecked(
                  res.ah5_group.ListPermission.Value.split(','),
                  res.ah5_group.ListPermission.ExtendValue.split(','),
                );
                break;
              case 8:
                // 只选了标签
                this.$refs.viewRangeAll.setChecked(
                  [],
                  [],
                  res.ah5_group.ListPermission.Value.split(','),
                );
                break;
              case 9: {
                // 部门+用户+标签混选
                const { User, Department, Tag } = JSON.parse(res.ah5_group.ListPermission.Value);
                this.$refs.viewRangeAll.setChecked(
                  User ? User.split(',') : [],
                  Department ? Department.split(',') : [],
                  Tag ? Tag.split(',') : [],
                );
              }
            }
            this.permission = 5; // 设置后统一归为5
          } else if (this.permission === 6) {
            this.permission = 3;
            this.listStrategy = res.ah5_group.ListPermission.Value.split(',').map((val) =>
              Number(val),
            );
          }
        });

        this.editableTabs = res.ah5_class.groups.map((item, index) => ({
          ...item,
          ah5_group_id: String(index - 0 + 1),
          lableData: [],
          productLabelChecked: [],
          diseaseLabelChecked: [],
          otherLabelChecked: [],
          strategy: [],
          permission: {
            type: 2,
            permission: 1,
            value: '',
            extendValue: '',
          },
        }));
        this.editableTabs.forEach((oriitem) => {
          const item = oriitem;
          item.arts = item.arts.map((val) => ({ ...val, istop: 1 }));
        });
        this.lableGroup = res.ah5_group.groups;
        this.editableTabs.forEach((oriitem) => {
          const item = oriitem;
          this.lableGroup.forEach((val) => {
            if (item.group_name === val.group_name) {
              item.lableData.push(val);
              item.permission = {
                permission: val.PermissionInfo.Permission,
                value: val.PermissionInfo.Value,
                extendValue: val.PermissionInfo.ExtendValue,
                type: 2,
              };
              if (item.permission.permission === 6) {
                item.strategy = item.permission.value.split(',').map((val) => Number(val));
              }
            }
          });
        });
        this.$nextTick(() => {
          for (let i = 0; i < this.editableTabs.length; i++) {
            const tab = this.editableTabs[i].permission;
            if ([4, 5, 7, 8, 9].includes(tab.permission)) {
              // 对于企业微信选择人员查看范围进行设置
              switch (tab.permission) {
                case 4:
                  // 只选了部门
                  this.$refs.viewRangeTab[i].setChecked([], tab.value.split(','));
                  break;
                case 5:
                  // 只选了用户
                  this.$refs.viewRangeTab[i].setChecked(tab.value.split(','), []);
                  break;
                case 7:
                  // 部门和人混选
                  this.$refs.viewRangeTab[i].setChecked(
                    tab.value.split(','),
                    tab.extendValue.split(','),
                  );
                  break;
                case 8:
                  // 只选了标签
                  this.$refs.viewRangeTab[i].setChecked([], [], tab.value.split(','));
                  break;
                case 9: {
                  // 部门+用户+标签混选
                  const { User, Department, Tag } = JSON.parse(tab.value);
                  this.$refs.viewRangeTab[i].setChecked(
                    User ? User.split(',') : [],
                    Department ? Department.split(',') : [],
                    Tag ? Tag.split(',') : [],
                  );
                }
              }
              tab.permission = 5;
            }
          }
        });
        if (this.editableTabs.length) {
          this.editableTabsValue = this.editableTabs[0].ah5_group_id;
        }
        this.tabIndex = String(this.editableTabs.length);
        this.editableTabs.forEach((oriitem) => {
          const item = oriitem;
          if (item.top_art_ids.length > 0) {
            item.arts = [
              ...new Set(this.optionsLabels(item.top_art_ids, item.arts).concat(item.arts)),
            ];
          }
        });
        this.noticeList = res.noticeInfo.filter((item) => item.Type === 1);
        this.toolbarList = res.noticeInfo.filter((item) => item.Type === 2);
        this.projectList = (res.projects || []).map((item) => {
          return {
            Title: item.name,
            Desc: item.desc,
            Icon: item.icon,
            Link: item.link,
            Id: item.id,
            Color: item.color,
          };
        });
        this.loading = false;
      });
    },
    handleNotop(val, index) {
      // 取消置顶
      this.editableTabs.forEach((oriitem) => {
        const item = oriitem;
        if (this.editableTabsValue === item.ah5_group_id) {
          item.top_art_ids = item.top_art_ids.filter((v) => v !== val);

          item.lableData.forEach((k) => {
            k.top_art_ids = item.top_art_ids;
          });

          const value = item.arts[index];
          value.istop = 1;
          item.arts = item.arts.filter((k) => k.art_id !== val);
          item.arts.push(value);
        }
      });
    },
    handleTop(val, index) {
      // 置顶文章
      this.editableTabs.forEach((oriitem) => {
        const item = oriitem;
        if (this.editableTabsValue === item.ah5_group_id) {
          if (item.top_art_ids.length >= 3) {
            this.$message.error('最多置顶3篇文章，请先取消某篇文章的置顶');
            return false;
          }
          item.top_art_ids.unshift(val);

          item.lableData.forEach((orik) => {
            const k = orik;
            k.top_art_ids = item.top_art_ids;
          });

          item.arts[index].istop = 2;
          this.toFirst(item.arts, index);
        }
      });
      // console.log(this.editableTabs);
    },
    toFirst(fieldData, index) {
      fieldData.unshift(fieldData.splice(index, 1)[0]);
    },
    optionsLabels(val = [], options = []) {
      // 截取出置顶文章
      const arr = [];
      for (const item of options) {
        for (const i of val) {
          if (item.art_id === i) {
            item.istop = 2;
            arr.push(item);
          }
        }
      }
      return arr;
    },
    calculatePermissionList() {
      let value = '';
      let extendValue = '';
      if ([4, 5, 7, 8, 9].includes(this.permission)) {
        // 选择了企业内部的情况下，查询列表的查看范围
        const { userIds, departIds, labelIds, isChooseAll } = this.$refs.viewRangeAll.submitForm();
        const [hasUser, hasDepart, hasLabel] = [
          userIds.length !== 0,
          departIds.length !== 0,
          labelIds.length !== 0,
        ];
        if (isChooseAll) {
          this.permission = 9;
          value = JSON.stringify({
            User: 'all',
            Department: 'all',
            Tag: 'all',
          });
          return;
        }
        if (!hasUser && !hasDepart && !hasLabel) {
          // 都没选
          this.$message.warning('请选择文章列表的查看范围');
          return;
        }
        if (hasUser && !hasDepart && !hasLabel) {
          // 只选了人
          this.permission = 5;
          value = userIds.join(',');
        } else if (!hasUser && hasDepart && !hasLabel) {
          // 只选了部门
          this.permission = 4;
          value = departIds.join(',');
        } else if (!hasUser && !hasDepart && hasLabel) {
          // 只选了标签
          this.permission = 8;
          value = labelIds.join(',');
        } else if (hasUser && hasDepart && !hasLabel) {
          // 部门+人
          this.permission = 7;
          value = userIds.join(',');
          extendValue = departIds.join(',');
        } else {
          // 后端认为的剩余情况
          this.permission = 9;
          value = JSON.stringify({
            User: userIds.join(','),
            Department: departIds.join(','),
            Tag: labelIds.join(','),
          });
        }
      } else if (this.permission === 3) {
        // 选择了策略
        if (this.listStrategy.length) {
          value = this.listStrategy.join(',');
          this.permission = 6;
        }
      }
      return { value, extendValue };
    },
    calculatePermissionTab() {
      for (let i = 0; i < this.editableTabs.length; i++) {
        const tab = this.editableTabs[i].permission;
        if ([4, 5, 7, 8, 9].includes(tab.permission)) {
          const { userIds, departIds, labelIds, isChooseAll } =
            this.$refs.viewRangeTab[i].submitForm();
          const [hasUser, hasDepart, hasLabel] = [
            userIds.length !== 0,
            departIds.length !== 0,
            labelIds.length !== 0,
          ];
          if (isChooseAll) {
            tab.permission = 9;
            tab.value = 'all';
            return;
          }
          if (!hasUser && !hasDepart && !hasLabel) {
            // 都没选
            tab.$message.warning('请选择文章列表的查看范围');
            return;
          }
          if (hasUser && !hasDepart && !hasLabel) {
            // 只选了人
            tab.permission = 5;
            tab.value = userIds.join(',');
          } else if (!hasUser && hasDepart && !hasLabel) {
            // 只选了部门
            tab.permission = 4;
            tab.value = departIds.join(',');
          } else if (!hasUser && !hasDepart && hasLabel) {
            // 只选了标签
            tab.permission = 8;
            tab.value = labelIds.join(',');
          } else if (hasUser && hasDepart && !hasLabel) {
            // 部门+人
            tab.permission = 7;
            tab.value = userIds.join(',');
            tab.extendValue = departIds.join(',');
          } else {
            // 后端认为的剩余情况
            tab.permission = 9;
            tab.value = JSON.stringify({
              User: userIds.join(','),
              Department: departIds.join(','),
              Tag: labelIds.join(','),
            });
          }
          // 选择了企业内部
          // const rangeList = this.$refs.viewRangeTab[i].submitForm();
          // if (rangeList.departIds.length === 0 || rangeList.userIds.length === 0) {
          //   if (rangeList.departIds.length === 0 && rangeList.userIds.length === 0) {
          //     // 部门和人都没选
          //     this.$message.warning(`请选择标签页 ${this.editableTabs[i].group_name} 的查看范围`);
          //     return;
          //   }
          //   if (rangeList.userIds.length !== 0) {
          //     // 只选了用户
          //     tab.permission = 5;
          //     tab.value = rangeList.userIds.join(',');
          //   } else if (rangeList.departIds.length !== 0) {
          //     // 只选了部门
          //     tab.permission = 4;
          //     tab.value = rangeList.departIds.join(',');
          //   }
          //   tab.extendValue = '';
          // } else {
          //   // 部门和人混选
          //   tab.permission = 7;
          //   tab.value = rangeList.userIds.join(',');
          //   tab.extendValue = rangeList.departIds.join(',');
          // }
        } else if (tab.permission === 6) {
          // 对于公众号选择策略进行处理（6）
          tab.value = this.editableTabs[i].strategy.join(',');
          tab.extendValue = '';
        }
      }
    },
    hanldeH5Preview() {
      // 打开预览窗口
      const banner = this.bannerData.map((item, index) => {
        return { ...item, sort: index - 0 + 1 };
      });
      if (this.name === '') {
        this.$message.error('页面名称不可为空！');
        return false;
      }
      const { value, extendValue } = this.calculatePermissionList();
      this.calculatePermissionTab();

      this.h5PreviewVisible = true;
      let arr = [];
      this.editableTabs.forEach((item) => {
        arr = [...arr, ...item.lableData];
      });
      for (const label of arr) {
        for (const tab of this.editableTabs) {
          if (label.group_name === tab.group_name) {
            label.PermissionInfo = {
              Permission: tab.permission.permission,
              Type: tab.permission.type,
              Value: tab.permission.value,
            };
            delete label.arts;
          }
        }
      }
      if (this.$route.query.type === 'edit') {
        const req = {
          ah5_info: {
            ah5_id: this.$route.query.ah5_id,
            banners: banner,
            name: this.name,
            status: 1,
            groups: arr,
            projects: this.projectList.map((item) => {
              return {
                name: item.Title,
                desc: item.Desc,
                icon: item.Icon,
                link: item.Link,
                id: item.Id,
                color: item.Color,
              };
            }),
          },
          Channel: {
            Type: this.channelType === '公众号' ? 1 : 2,
            Id: this.channelType === '公众号' ? this.channelAppId : this.channelId.toString(),
          },
          ListPermission: {
            Type: 1, // 列表查看权限
            Permission: this.permission,
            Value: value,
            ExtendValue: extendValue,
          },
          noticeInfo: [...this.noticeList, ...this.toolbarList],
          IsCanCollect: this.canCollect,
        };
        AEditArticleH5(req)
          .then(() => {
            const id = this.$route.query.ah5_id;
            this.h5Preview = `${this.protocol}://${this.url}/pages/article/active/index?id=${id}`;
            // this.h5Preview = `https://v2testh5.tsepcn.com/pages/article/active/index?id=${id}`;
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      } else {
        const req = {
          ah5_info: {
            ah5_id: this.ah5_id,
            banners: banner,
            name: this.name,
            status: 1,
            groups: arr,
            projects: this.projectList.map((item) => {
              return {
                name: item.Title,
                desc: item.Desc,
                icon: item.Icon,
                link: item.Link,
                id: item.Id,
                color: item.Color,
              };
            }),
          },
          Channel: {
            Type: this.channelType === '公众号' ? 1 : 2,
            Id: this.channelType === '公众号' ? this.channelAppId : this.channelId.toString(),
          },
          ListPermission: {
            Type: 1, // 列表查看权限
            Permission: this.permission,
            Value: value,
            ExtendValue: extendValue,
          },
          noticeInfo: [...this.noticeList, ...this.toolbarList],
          IsCanCollect: this.canCollect,
        };
        AEditArticleH5(req)
          .then((res) => {
            this.ah5_id = res.ah5_id;
            const id = res.ah5_id;
            this.h5Preview = `${this.protocol}://${this.url}/pages/article/active/index?id=${id}`;
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      }
      this.resetPermission();
    },
    getEditData(val) {
      // 修正保存已发布文章
      val = this.status ? 2 : val;

      const { value, extendValue } = this.calculatePermissionList();
      this.calculatePermissionTab();

      // 保存与发布接口
      const banner = this.bannerData.map((item, index) => {
        return { ...item, sort: index - 0 + 1 };
      });
      let arr = [];
      this.editableTabs.forEach((item) => {
        arr = [...arr, ...item.lableData];
      });
      for (const label of arr) {
        for (const tab of this.editableTabs) {
          if (label.group_name === tab.group_name) {
            label.PermissionInfo = {
              Permission: tab.permission.permission,
              Type: tab.permission.type,
              Value: tab.permission.value,
              ExtendValue: tab.permission.extendValue,
            };
            delete label.arts;
          }
        }
      }
      if (this.$route.query.type === 'edit') {
        const req = {
          ah5_info: {
            ah5_id: this.$route.query.ah5_id,
            banners: banner,
            name: this.name,
            status: val,
            groups: arr,
            projects: this.projectList.map((item) => {
              return {
                name: item.Title,
                desc: item.Desc,
                icon: item.Icon,
                link: item.Link,
                id: item.Id,
                color: item.Color,
              };
            }),
          },
          Channel: {
            Type: this.channelType === '公众号' ? 1 : 2,
            Id: this.channelType === '公众号' ? this.channelAppId : this.channelId.toString(),
          },
          ListPermission: {
            Type: 1, // 列表查看权限
            Permission: this.permission,
            Value: value,
            ExtendValue: extendValue,
          },
          noticeInfo: [...this.noticeList, ...this.toolbarList],
          IsCanCollect: this.canCollect,
        };
        // console.log(req);
        // return; // 测试，避免发送请求
        AEditArticleH5(req)
          .then(() => {
            // console.log(res);
            if (val === 1) {
              this.$message.success('保存成功！');
              const id = this.$route.query.ah5_id;
              this.h5Preview = `${this.protocol}://${this.url}/pages/article/active/index?id=${id}`;
            }
            if (val === 2) {
              this.$message.success('发布成功！');
              this.h5PreviewVisible = false;
              this.g_tourl('/saas/artilceList.html');
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      } else {
        const req = {
          ah5_info: {
            ah5_id: this.ah5_id,
            banners: banner,
            name: this.name,
            status: val,
            groups: arr,
            projects: this.projectList.map((item) => {
              return {
                name: item.Title,
                desc: item.Desc,
                icon: item.Icon,
                link: item.Link,
                id: item.Id,
                color: item.Color,
              };
            }),
          },
          Channel: {
            Type: this.channelType === '公众号' ? 1 : 2,
            Id: this.channelType === '公众号' ? this.channelAppId : this.channelId.toString(),
          },
          ListPermission: {
            Type: 1, // 列表查看权限
            Permission: this.permission,
            Value: value,
            ExtendValue: extendValue,
          },
          noticeInfo: [...this.noticeList, ...this.toolbarList],
          IsCanCollect: this.canCollect,
        };
        // console.log(req);
        // return; // 测试，避免发送请求
        AEditArticleH5(req)
          .then((res) => {
            // console.log(res);
            if (val === 1) {
              this.$message.success('保存成功！');
              this.$router.push({
                query: {
                  type: 'add',
                  ah5_id: res.ah5_id,
                },
              });
              this.ah5_id = res.ah5_id;
              const id = res.ah5_id;
              this.h5Preview = `${this.protocol}://${this.url}/pages/article/active/index?id=${id}`;
            }
            if (val === 2) {
              this.$message.success('发布成功！');
              this.h5PreviewVisible = false;
              this.g_tourl('/saas/artilceList.html');
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      }
      this.resetPermission();
    },
    resetPermission() {
      if ([4, 5, 7, 8, 9].includes(this.permission)) {
        this.permission = 5;
      } else if (this.permission === 6) {
        this.permission = 3;
      }
      for (const tab of this.editableTabs) {
        if ([4, 5, 7, 8, 9].includes(tab.permission.permission)) {
          tab.permission.permission = 5;
        }
      }
    },
    handleSave() {
      // 保存
      if (this.name === '') {
        this.$message.error('页面名称不可为空！');
        return false;
      }
      // for (const item of this.editableTabs) {
      //   if (item.arts.length < 1) {
      //     this.$message.error(`${item.group_name}下文章数量为0，请重新选择文章`);
      //     return false;
      //   }
      // }
      this.getEditData(1);
    },
    handleRelease() {
      // 发布
      if (this.name === '') {
        this.$message.error('页面名称不可为空！');
        return false;
      }
      if (this.status) {
        this.$message.warning('当前列表已发布，点击保存即可生效更改内容');
        return false;
      }
      // for (const item of this.editableTabs) {
      //   if (item.arts.length < 1) {
      //     this.$message.error(`${item.group_name}下文章数量为0，请重新选择文章`);
      //     return false;
      //   }
      // }
      this.getEditData(2);
    },
    handleCheckLabel() {
      // 通过标签添加文章
      const arr = [];
      arr.push(
        ...this.product.checked.map((item) => {
          return {
            LabelType: -1, // 产品标签的type约定为-1
            Id: item.id,
          };
        }),
      );
      for (const labelGroup of this.labelGroupList) {
        arr.push(...labelGroup.selectValue);
      }
      // console.log(arr);
      this.editableTabs.forEach((val) => {
        if (this.editableTabsValue === val.ah5_group_id) {
          // item.lableData = arr;
          const groupName = val.group_name;
          const top = val.top_art_ids;
          const before = new Map();
          for (const item of val.lableData) {
            before.set(JSON.stringify([item.tag_type, item.tag_id]), [
              item.ah5_group_id,
              item.group_id,
            ]);
          }
          val.lableData = arr.map((item) => {
            return {
              tag_type: item.LabelType,
              tag_id: String(item.Id),
              group_name: groupName,
              top_art_ids: top,
            };
          });
          for (const item of val.lableData) {
            if (before.has(JSON.stringify([item.tag_type, item.tag_id]))) {
              [item.ah5_group_id, item.group_id] = before.get(
                JSON.stringify([item.tag_type, item.tag_id]),
              );
            }
          }
        }
      });
      const newArr = arr.map((item) => {
        return {
          tag_id: String(item.Id),
          tag_type: String(item.LabelType),
        };
      });
      // console.log(newArr);
      this.tabLoading = true;
      if (newArr.length < 1) {
        this.$message.error('请至少勾选一个标签');
        this.tabLoading = false;
        return false;
      }
      GetArticleH5ByTagID({
        tags: newArr,
        channelInfo: {
          Type: this.channelType === '公众号' ? 1 : 2,
          Id:
            this.channelType === '公众号'
              ? this.channelAppId.toString()
              : this.channelId.toString(),
        },
      }).then((res) => {
        this.editableTabs.forEach((item) => {
          if (this.editableTabsValue === item.ah5_group_id) {
            item.arts = res.arts.map((val) => ({ ...val, istop: 1 }));
            if (item.top_art_ids.length) {
              const topArr = item.top_art_ids;
              item.top_art_ids = [];
              topArr.forEach((val) => {
                item.arts.forEach((k) => {
                  if (k.art_id === val) {
                    item.top_art_ids.push(k.art_id);
                    item.arts = this.optionsLabels(item.top_art_ids, item.arts).concat(
                      item.arts.filter((p) => p.istop === 1),
                    );
                  }
                });
              });
            }
          }
        });
        this.tabLoading = false;
      });
      this.articleVisible = false;
    },
    handleAddArticle() {
      // 添加文章
      this.articleVisible = true;
      // 寻找当前所在tab
      for (const item of this.editableTabs) {
        if (this.editableTabsValue === item.ah5_group_id) {
          this.checkBoxAll = item.lableData.map((val) => ({
            id: val.tag_id,
            label_type: val.tag_type,
          }));
          console.log(this.checkBoxAll);
          break;
        }
      }

      // 对product label进行检测，有则加入结果
      const productCheckList = this.checkBoxAll
        .filter((item) => {
          return item.label_type === -1;
        })
        .map((item) => item.id);
      this.product.checked.splice(0, this.product.checked.length);
      for (const label of this.product.list) {
        if (productCheckList.includes(String(label.id))) {
          this.product.checked.push(label);
        }
      }
      this.handleProductCheckChange();

      // 检测label是否已被选择
      const hasChecked = function (label, checkList) {
        for (const check of checkList) {
          if (
            String(label.LabelType) === String(check.label_type) &&
            String(label.Id) === String(check.id)
          ) {
            return true;
          }
        }
        return false;
      };
      // 对所有动态label进行检测，有则加入选择结果
      for (const labelGroup of this.labelGroupList) {
        labelGroup.selectValue.splice(0, labelGroup.selectValue.length);
        for (const label of labelGroup.LabelList) {
          if (hasChecked(label, this.checkBoxAll)) {
            labelGroup.selectValue.push(label);
          }
        }
        this.handleCheckChange(labelGroup.id);
      }
    },
    handleDetectClassification() {
      // 删除分类
      this.$confirm('确定删除此分类吗?')
        .then(() => {
          this.editableTabs = this.editableTabs.filter(
            (item) => item.ah5_group_id !== this.editableTabsValue,
          );
          this.editableTabsValue = this.editableTabs[this.editableTabs.length - 1].ah5_group_id;
        })
        .catch(() => {});
    },
    handleDelectBanner(row) {
      // 删除运营位
      this.bannerData = this.bannerData.filter((item) => {
        return item.banner_id !== row.banner_id;
      });
    },
    handleDelectNotice(index, rows) {
      // 删除通知栏/底部通知栏
      rows.splice(index, 1);
    },
    handleEditProject(index) {
      this.projectForm = { ...this.projectList[index] };
      this.projectEdit = true;
      this.projectEditIndex = index;
      this.projectVisible = true;
    },
    // 新增通知栏/底部通知栏
    saveNotice(Type = 1, list) {
      const form = Type === 1 ? 'noticeForm' : 'toolbarForm';
      if (this[form].Title === '' || this[form].Icon === '' || this[form].Link === '') {
        this.$message.warning('请完整填写后保存');
        return;
      }
      if (!this.hasProtocol(this[form].Link) && !this.judgeArtType(this[form].Link)) {
        this.$message.warning(`请输入 ${this.channelType} 渠道的链接ID`);
        return;
      }
      list.push({
        Type,
        ...this[form],
      });
      this.noticeVisible = false;
      this.toolbarVisible = false;
    },
    saveProject() {
      if (
        this.projectForm.Title === '' ||
        this.projectForm.Link === '' ||
        this.projectForm.Color === ''
      ) {
        this.$message.warning('请完整填写后保存');
        return;
      }
      if (this.projectEdit) {
        this.projectList.splice(this.projectEditIndex, 1, { ...this.projectForm });
        this.projectEdit = false;
      } else {
        this.projectList.push({
          ...this.projectForm,
        });
      }
      this.projectVisible = false;
    },
    addOperaBannerList() {
      // 确认选择运营位
      this.bannerData = this.selectionData;
      this.operatVisible = false;
    },
    H5SelectionChange(val) {
      // this.selectH5Banner = val;
      // this.bannerData = val;
      console.log(val);
      this.selectionData = val;
      // this.checkBanner = val;
    },
    handleOperat() {
      // 打开添加运营位列表窗口
      this.operatVisible = true;
      this.bannerDataLoading = true;

      GetBanners({
        entry_type: 3, // H5运营位
        entry_status: 2, // 已上线
        page_index: this.H5OperaPageIndex,
        page_size: this.H5OperaPageSize,
      })
        .then((res) => {
          // console.log(res);
          this.H5OperaPageTotal = res.total;
          this.H5OperaBanner = res.banner_list;
          this.bannerDataLoading = false;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    // 运营位分页
    handleOperaIndexChange(val) {
      this.H5OperaPageIndex = val;
      this.handleOperat();
    },
    handleChange() {
      // 更换分类名称
      for (const item of this.editableTabs) {
        if (item.ah5_group_id === this.editableTabsValue) {
          item.group_name = this.modify;
          item.lableData.forEach((val) => {
            val.group_name = this.modify;
          });
          // console.log(item.lableData);
        }
      }
      this.modify = '';
    },
    addTab() {
      // 添加分类
      this.modify = '';
      if (this.editableTabs.length >= 30) {
        this.$message.error('最多只能添加30个分类');
        return false;
      }
      this.tabIndex = `${this.tabIndex - 0 + 1}`;
      this.editableTabs.push({
        group_name: `新增分类${this.tabIndex}`,
        ah5_group_id: this.tabIndex,
        arts: [],
        top_art_ids: [],
        lableData: [],
        permission: {
          type: 2,
          permission: 1,
          value: '',
          extendValue: '',
        },
        strategy: [],

        productLabelChecked: [],
        diseaseLabelChecked: [],
        otherLabelChecked: [],
      });
      this.editableTabsValue = this.editableTabs[this.editableTabs.length - 1].ah5_group_id;
    },
    rowDrop() {
      // 拖动事件
      this.drag = true;
      if (this.drag) {
        const tbody = document.querySelectorAll(`.bannerData .el-table__body-wrapper tbody`);
        const _this = this;
        this.dragDorp = Sortable.create(tbody[0], {
          onEnd({ newIndex, oldIndex }) {
            const currRow = _this.bannerData.splice(oldIndex, 1)[0];
            _this.bannerData.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    closeRowDrop() {
      this.drag = false;
      this.dragDorp.destroy();
    },
    // 通知栏拖动
    rowDropNotice() {
      // 拖动事件
      this.dragNoticeList = true;
      if (this.dragNoticeList) {
        const tbody = document.querySelectorAll(`.noticeList .el-table__body-wrapper tbody`);
        const _this = this;
        this.dragDorpNotice = Sortable.create(tbody[0], {
          onEnd({ newIndex, oldIndex }) {
            const currRow = _this.noticeList.splice(oldIndex, 1)[0];
            _this.noticeList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    closeRowDropNotice() {
      this.dragNoticeList = false;
      this.dragDorpNotice.destroy();
    },
    // 底部工具栏拖动
    rowDropToolbar() {
      // 拖动事件
      this.dragToolbar = true;
      if (this.dragToolbar) {
        const tbody = document.querySelectorAll(`.toolbarList .el-table__body-wrapper tbody`);
        const _this = this;
        this.dragDorpToolbar = Sortable.create(tbody[0], {
          onEnd({ newIndex, oldIndex }) {
            const currRow = _this.toolbarList.splice(oldIndex, 1)[0];
            _this.toolbarList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    closeRowDropToolbar() {
      this.dragToolbar = false;
      this.dragDorpToolbar.destroy();
    },
    // 底部工具栏拖动
    rowDropProject() {
      // 拖动事件
      this.dragProjectList = true;
      if (this.dragProjectList) {
        const tbody = document.querySelectorAll(`.projectList .el-table__body-wrapper tbody`);
        const _this = this;
        this.dragDorpToolbar = Sortable.create(tbody[0], {
          onEnd({ newIndex, oldIndex }) {
            const currRow = _this.projectList.splice(oldIndex, 1)[0];
            _this.projectList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    closeRowDropProject() {
      this.dragProjectList = false;
      this.dragDropProject.destroy();
    },
    judgeArtType(artId) {
      // console.log(artId);
      // 计算id来源是否和文章列表的channel相匹配：企业微信文章id（纯数字），公众号微信文章id
      const r = /^\d+$/;
      if (r.test(artId)) {
        if (this.channelType === '企业微信') {
          return true;
        }
      } else if (this.channelType === '公众号') {
        return true;
      }
      return false;
    },
    hasProtocol(url) {
      return url.indexOf('http') !== -1;
    },
    resetProjectIcon() {
      this.projectForm.Icon = this.defaultProjectIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  position: relative;
  height: 80px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #303133;
  .details-img {
    position: absolute;
    top: 32.5px;
    left: 0;
    width: 24px;
    height: 24px;
    transform: rotateY(180deg);
  }
  .details-img:hover {
    color: rgb(47, 150, 255);
  }
  .details-return {
    position: absolute;
    top: 36px;
    width: 44px;
    height: 22px;
    left: 28px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #606266;
    letter-spacing: 0;
    cursor: pointer;
  }
  .details-return:hover {
    color: rgb(47, 150, 255);
  }
}
.contant {
  display: flex;
  // justify-content: space-evenly;
  // margin-top: 200px;
  .goback {
    position: fixed;
    top: 125px;
    left: 300px;
  }
}
.left {
  width: 360px;
  border-radius: 18px;
  border: 2px solid #e6e8ed;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    text-align: center;
    margin-top: 20px;
    min-height: 30px;
    text-indent: 16px;
    line-height: 30px;
  }
  .left-airtilce {
    min-height: 300px;
    overflow: auto;
    margin-top: 20px;
    border-top: 1px solid rgb(241, 241, 241);
    ::v-deep.el-tabs__item {
      text-align: center;
      width: 126px;
    }
    ::v-deep.el-tabs__nav {
      white-space: nowrap;
      position: relative;
      transition: transform 0.3s;
      /* float: left; */
      z-index: 2;
      display: flex;
      align-items: center;
    }
  }
}
.right {
  width: 628px;
  margin-left: 300px;
  .right-tit {
    display: flex;
    align-items: center;
    background: #f2f4f7;
    ::v-deep .el-form {
      margin-top: 20px;
      margin-left: 10px;
      .el-input__inner {
        width: 300px;
      }
    }
  }
  .oprating-list {
    margin-top: 20px;
    background: #f2f4f7;
    border: 1px solid #f2f4f7;
  }
  //   border: 3px solid rgba(187, 187, 187, 0.2);
  .operat-title {
    span {
      color: #313233;
      font-size: 14px;
    }
    box-sizing: border-box;
    padding: 0 8px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .article-classify {
    width: 628px;
    // height: 327px;
    // background: #f2f4f7;
    .options {
      margin-top: 15px;
      .el-button {
        height: 40px;
      }
      ::v-deep.el-form {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      ::v-deep.el-tabs__item {
        text-align: center;
        width: 126px;
      }
      ::v-deep.el-tabs__nav {
        white-space: nowrap;
        position: relative;
        transition: transform 0.3s;
        /* float: left; */
        z-index: 2;
        display: flex;
        align-items: center;
      }
      .add-artilce {
        border-bottom: 1px solid #e6e8ed;
        height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .span1 {
          color: #313233;
          font-size: 14px;
        }
        .span2 {
          font-size: 12px;
          color: #939599;
        }
      }
    }
  }
}
.submit {
  width: 628px;
  display: flex;
  justify-content: space-around;
  margin: 20px 0 0 300px;
}
.header {
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(237, 239, 242);
}
.content {
  margin-top: 20px;
  padding-bottom: 50px;
  border-bottom: 1px solid rgb(237, 239, 242);
}
.dialog-view-range-container {
  display: flex;
  .dialog-view-range-left {
    flex: 1;
    border-right: 1px solid #b1b1b1;
    .dialog-view-range-input {
      padding-right: 15px;
    }
  }
  .dialog-view-range-right {
    flex: 1;
  }
}
.no-tab-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .no-tab-span {
    color: #313233;
    font-size: 14px;
  }
}
.avatar {
  max-width: 32px;
  max-height: 32px;
}
.add-article-checkbox-group {
  .add-article-checkbox-container {
    width: 180px;
    display: inline-block;
    .add-article-checkbox {
      display: flex;
      align-items: center;
      overflow: visible;
      .box {
        width: 180px;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
.color-selector {
  display: inline-block;
  width: 39px;
  height: 39px;
  border-radius: 2px;
  position: relative;
}
.color-selector-inner {
  position: absolute;
  width: 32px;
  height: 32px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.color-selected {
  border: 2px solid #0069fa;
}
.icon-delete {
  height: 20px;
  line-height: 20px;
  width: 100px;
  position: absolute;
  top: 80px;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
